export type Icon = {
  src: string;
  title: string;
  alt: string;
};
export type Data = {
  icons: Icon[];
};

let data: Data | undefined;

if (__ENV__.MRQ_GAMING_AUTHORITY === 'UKGC') {
  data = {
    icons: [
      {
        src: '/assets/images1/trustFactors/18-logo.svg',
        title: '18+',
        alt: '18+'
      },
      {
        src: '/assets/images1/trustFactors/begambleaware.svg',
        title: 'GambleAware',
        alt: 'GambleAware'
      },
      {
        src: '/assets/images1/trustFactors/gambling-commission.svg',
        title: 'Gambling Commission',
        alt: 'Gambling Commission'
      },
      {
        src: '/assets/images1/trustFactors/mastercard-logo.svg',
        title: 'Mastercard',
        alt: 'Mastercard'
      },
      { src: '/assets/images1/trustFactors/visa-logo.svg', title: 'Visa', alt: 'Visa' },
      { src: '/assets/images1/trustFactors/paypal.svg', title: 'PayPal', alt: 'PayPal' },
      {
        src: '/assets/images1/trustFactors/pay-by-mobile.svg',
        title: 'Pay by mobile',
        alt: 'Pay by mobile'
      }
    ]
  };
}
if (__ENV__.MRQ_GAMING_AUTHORITY === 'MGA') {
  data = {
    icons: [
      {
        src: '/assets/images1/trustFactors/18-logo.svg',
        title: '18+',
        alt: '18+'
      },
      {
        src: '/assets/images1/trustFactors/mga.svg',
        title: 'MGA',
        alt: 'MGA'
      }
    ]
  };
}

const finalData = data;

export const meta = {
  title: 'MrQ',
  description: `50 Free Spins credited on first £10 deposit on Big Bass Splash, 10p per spin. Free Spins valid for 48 hours. All winnings are uncapped and credited to your real money balance. Full T&Cs apply.`
};

export default finalData;
